import React, { useEffect, useRef, useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import log from "./log.png";
import "./header.css";

const Header = () => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [mobileLocationOpen, setMobileLocationOpen] = useState(false);
  const overlayRef = useRef(null);

  // ✅ Scroll to top whenever route changes (works for ALL links)
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  useEffect(() => {
    if (mobileOpen) document.body.classList.add("menu-open");
    else document.body.classList.remove("menu-open");

    return () => document.body.classList.remove("menu-open");
  }, [mobileOpen]);

  const closeMobile = () => {
    setMobileOpen(false);
    setMobileLocationOpen(false);
  };

  const onOverlayClick = (e) => {
    if (e.target === overlayRef.current) closeMobile();
  };

  // ✅ helper so every click closes mobile (and route change scrolls top)
  const handleNavClick = () => {
    closeMobile();
    // scroll will also happen automatically because pathname changes
  };

  return (
    <nav>
      <div className="navbar">
        {/* Mobile hamburger */}
        <button
          className="menu-btn"
          aria-label="Open menu"
          type="button"
          onClick={() => setMobileOpen(true)}
        >
          <span className="bar" />
          <span className="bar" />
          <span className="bar" />
        </button>

        {/* Logo */}
        <div className="logo">
          <NavLink to="/" className="logo-link" onClick={handleNavClick}>
            <img className="logo-img" src={log} alt="Xceed Office" />
          </NavLink>
        </div>

        {/* Desktop links */}
        <div className="desktop-nav">
          <ul className="desktop-links">
            <li>
              <NavLink to="/about" onClick={handleNavClick}>
                About Us
              </NavLink>
            </li>

            {/* Desktop dropdown */}
            <li className="nav-dd">
              <span className="nav-dd__trigger">
                Location 

                <span className="nav-dd__caret">▾</span>
              </span>

              <div className="nav-dd__menu" role="menu">
                <div className="nav-dd__item nav-dd__item--hasSub">
                  <div className="nav-dd__subTrigger">
                    New York <span className="nav-dd__caret">▸</span>
                  </div>

                  <div className="nav-dd__subMenu" role="menu">
                    <NavLink
                      className="nav-dd__link"
                      to="/location"
                      onClick={handleNavClick}
                    >
                      Houston
                    </NavLink>
                     <  NavLink  style={{display:"none"}}
                      className="nav-dd__link"
                      to="/locations/new-york/brooklyn"
                      onClick={handleNavClick}
                    >
                      Brooklyn
                    </NavLink>
                    <NavLink style={{display:"none"}}
                      className="nav-dd__link"
                      to="/locations/new-york/queens"
                      onClick={handleNavClick}
                    >
                      Queens
                    </NavLink>
                  </div>
                </div>

                <NavLink style={{display:"none"}} className="nav-dd__link" to="/location" onClick={handleNavClick}>
                  Houston (Main)
                </NavLink>
              </div>
            </li>

            <li>
              <NavLink to="/pricing" onClick={handleNavClick}>
                Pricing
              </NavLink>
            </li>
            <li>
              <NavLink to="/contact" onClick={handleNavClick}>
                Contact
              </NavLink>
            </li>
          </ul>
        </div>

        {/* Mobile overlay + drawer */}
        <div
          ref={overlayRef}
          className={`mobile-overlay ${mobileOpen ? "open" : ""}`}
          onClick={onOverlayClick}
        >
          <div className="mobile-drawer" role="dialog" aria-modal="true">
            <div className="drawer-top">
              <div className="drawer-brand">
                <img src={log} alt="Xceed Office" />
              </div>

              <button
                className="close-btn"
                aria-label="Close menu"
                type="button"
                onClick={closeMobile}
              >
                ×
              </button>
            </div>

            {/* Mobile links */}
            <ul style={{ background: "black", marginTop: "-8%" }} className="drawer-links">
              <li>
                <NavLink to="/about" onClick={handleNavClick}>
                  About Us
                </NavLink>
              </li>

              {/* Mobile Location accordion */}
              <li className="drawer-accordion">
                <button
                  type="button"
                  className="drawer-accordion__btn"
                  onClick={() => setMobileLocationOpen((v) => !v)}
                  aria-expanded={mobileLocationOpen}
                >
                  Location{" "}
                  <span className="drawer-accordion__caret">
                    {mobileLocationOpen ? "▾" : "▸"}
                  </span>
                </button>

                {mobileLocationOpen && (
                  <div className="drawer-accordion__panel">
                    <div className="drawer-subgroup__title">New York</div>

                    <NavLink
                      to="/locations/new-york/manhattan"
                      onClick={handleNavClick}
                    >
                      Manhattan
                    </NavLink>
                    <NavLink
                      to="/locations/new-york/brooklyn"
                      onClick={handleNavClick}
                    >
                      Brooklyn
                    </NavLink>
                    <NavLink
                      to="/locations/new-york/queens"
                      onClick={handleNavClick}
                    >
                      Queens
                    </NavLink>

                    <div className="drawer-subgroup__divider" />

                    <NavLink to="/location" onClick={handleNavClick}>
                      Houston (Main)
                    </NavLink>
                  </div>
                )}
              </li>

              <li>
                <NavLink to="/pricing" onClick={handleNavClick}>
                  Pricing
                </NavLink>
              </li>
              <li>
                <NavLink to="/contact" onClick={handleNavClick}>
                  Contact
                </NavLink>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Header;